import React from 'react';
import styled from '@emotion/styled';
import Drawer from '@mui/material/Drawer';
import colors from '../Theme/colors';
import gradients from '../Theme/gradients';

import MenuList from '../Typography/MenuList';
import {
  List,
  ListItem,
} from '../List';
import breakpoints from '../Theme/breakpoints';

const DrawerList = styled(List)`
&&& {
  padding: 0;
  & > a {
    &:focus {
      outline: none;
    }
  }
  overflow: scroll;
  @media (min-width: ${breakpoints.xssm}px) {
    overflow: inherit;
  }
}
`;

const DrawerListItem = styled(ListItem)`
  &&& {
    height: 57px;
    border-radius: 0;
    /* override inline style generated by mdc */
    /* stylelint-disable-next-line declaration-no-important */
    margin: 0 !important;
    /* override inline style generated by mdc */
    color: ${({ theme }) => theme.colors.greyDark};
    padding-left: 2rem;
    background-color: rgba(0, 0, 0, 0.08);
  }
`;

const DrawerText = styled(MenuList)`
  && {
    text-decoration: none;
  }
`;

const ActiveListItem = styled(ListItem, {
  shouldForwardProp: (propertyName) => propertyName !== 'executive',
})<{ executive?: boolean }>`
  &&& {
    height: 57px;
    border-radius: 0;
    /* override inline style generated by mdc */
    /* stylelint-disable-next-line declaration-no-important */
    margin: 0 !important;
    /* override inline style generated by mdc */
    color: ${({ theme }) => theme.colors.greyDark};
    cursor: pointer;
    background-color: ${({ executive } : { executive?: boolean }) => (
    executive ? colors.black : 'inherit')};
    background-image: ${({ executive } : { executive?: boolean }) => (
    executive ? `linear-gradient(0.04turn, ${gradients.executive})` : 'none')};
    && a, && a div span {
    ${(
    { executive } : { executive?: boolean },
  ) => executive && `color: ${colors.white};`}
}
  }
`;

const ModalDrawer = ({ ...properties }) => <Drawer {...properties} />;

const StyledDrawer = styled(ModalDrawer)`
  && {
    .MuiDrawer-paper {
      width: 256px;
    }
  }
`;

export {
  ActiveListItem, DrawerText,
  DrawerListItem, DrawerList, ModalDrawer, StyledDrawer,
};
